import { cva } from '@repo/pandacss/css';

export const toastRecipe = cva({
  base: {
    display: 'grid',
    gridTemplateColumns: '[auto 1fr auto]',
    alignItems: 'center',
    gap: '2',
    bg: 'common.white',
    rounded: 'md',
    border: '[1px solid {colors.neutral.lighter-2}]',
    boxShadow: '[0 8px 24px rgba(0,0,0,0.12)]',
    py: '2',
    px: '3',
    width: '[100%]',
    maxWidth: '[450px]',
    pointerEvents: 'auto',
    color: 'neutral.darkest',
    textStyle: 'body.small',
    borderLeft: '[4px solid]',
  },
  variants: {
    type: {
      error: { borderLeftColor: 'reds.main' },
      info: { borderLeftColor: 'blues.main' },
      success: { borderLeftColor: 'greens.main' },
    },
  },
});

export const toastIconRecipe = cva({
  base: {
    flexShrink: '[0]',
    width: '[20px]',
    height: '[20px]',
    borderRadius: 'full',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '[12px]',
  },
  variants: {
    type: {
      error: { bg: 'reds.lightest', color: 'reds.main' },
      info: { bg: 'blues.lightest', color: 'blues.main' },
      success: { bg: 'greens.lightest', color: 'greens.main' },
    },
  },
});
